   <template>
  <div class="app7" :class="{ app7White: isWhite }">
    <div class="head" :class="{ headWhite: isWhite }">
      <van-search
        v-model="questionNameLike"
        placeholder="请输入关键词"
        @input="questionLike"
        v-if="isOldShow"
        class="OldInput"
        :clearable="false"
      />

      <div class="NewInputZu" v-if="isNewInputShow">
        <van-search
          v-model="questionNameLike"
          placeholder="请输入关键词"
          @input="questionLike"
          class="NewInput"
          :clearable="false"
        />
        <p @click="clearInput">取消</p>
      </div>
    </div>

    <div class="container7" :class="{ container7White: isWhite }">
      <div class="helpList">
        <div v-for="item in helpList1" :key="item.id" class="inHelp">
          <div class="questionTitle">{{ item.question }}</div>
          <div class="answer">
            {{ item.answer }}
          </div>
          <div class="tips">
            {{ item.tips }}
          </div>
        </div>
      </div>
    </div>
    <div class="wule">
      <div class="leftStyle">
        <div class="shadowLine left"></div>
      </div>
      <span> <img src="../assets/images/lines2.svg" alt="" /></span>
      <div class="centerWord">没有更多了</div>
      <span> <img src="../assets/images/lines2.svg" alt="" /></span>
      <div class="rightStyle">
        <div class="shadowLine right"></div>
      </div>
    </div>
  </div>
</template>

<script>
// import qs from "qs";
import { doRem } from "../utils/setrem";
import Vue from "vue";
import { Search } from "vant";
import { DropdownMenu, DropdownItem } from "vant";
import { List } from "vant";
// import { Dialog } from "vant";
import { Icon } from "vant";
Vue.use(Icon);

Vue.use(List);

Vue.use(DropdownMenu);
Vue.use(DropdownItem);

Vue.use(Search);

export default {
  mounted() {

    this.helpList1 = JSON.parse(JSON.stringify(this.helpList));
  },
  data() {
    return {
      commonList: true,
      isLike: false,
      isWhite: false,
      isOldShow: true,
      isBottomTipShow: false,
      isNewInputShow: false,

      areaPopup: false,
      juliPopup: false,

      questionNameLike: "",

      helpList: [
        {
          id: 1,
          question: "昆山市民卡能到上海使用吗?",
          answer:
            "您好，自2009年起昆山市民卡、昆通卡可用于乘坐上海公交车、地铁交通工具。",
          tips: "小贴士：关注”昆山市民卡”公众号可获取更多互联互通城市信息。",
        },
        {
          id: 2,
          question: "新老市民卡的区别有哪些?",
          answer:
            "您好，新市民卡是集银行、小额电子钱包（俗称公交钱包）两大功能为一体的智能IC卡，不再含有医保功能；老市民卡是集社保卡、小额支付卡、银行卡于一身的“三合一”卡，此卡于2016年起停止发放。",
          tips: "小贴士：关注“昆山市民卡“公众号可获取更多市民卡发展历程。",
        },
        {
          id: 3,
          question: "在昆山的外地人可以办理全新市民卡吗?",
          answer:
            "您好，可以办理新市民卡。新市民卡不限户籍，对新老昆山人免费发放，外籍人士凭有效证件均可办理。",
          tips: "",
        },
        {
          id: 4,
          question: "新市民卡、新社保卡在什么地方办理？",
          answer:
            "您好，新市民卡办理请至昆山农商银行任一网点柜面办理；新社保卡办理请至全市各区镇的15个便民服务中心或劳动保证所办理。  ",
          tips: "",
        },
        {
          id: 5,
          question: "市民卡、昆通卡公交电子钱包充值网点有哪些?",
          answer:
            "您好，市民卡、昆通卡公交电子钱包充值方式分为人工充值、云充值。人工充值：市民持卡至昆山农商银行本地任一网点或昆山市公交便民服务中心网点办理充值；云充值：市民通过'鹿路通'APP进行云充值。",
          tips:
            "小贴士：人工充值网点及云充值的补登点可通过'鹿路通'APP或'昆山市民卡'公众号查询",
        },
        {
          id: 6,
          question: "昆通卡无法乘坐公交和租借自行车?",
          answer:
            "您好，市民可持旧卡及收据至珠江路市民文化广场公交便民服务中心（市游泳馆西侧）3号窗口办理换卡业务。",
          tips:
            "小贴士：公交便民中心工作时间：周一至周日7:30-12:00,13:00-18:00咨询电话：57938555",
        },
        {
          id: 7,
          question: "昆山市民卡能不能在苏州坐地铁？",
          answer:
            "您好，昆山老市民卡（卡号以'2153'开头）不支持苏州地铁刷卡消费；昆山新市民卡和新昆通卡（卡号以'31048315'开头）支持苏州地铁出刷卡消费。",
          tips: "小贴士：关注“昆山市民卡“公众号获取更多互联互通城市信息",
        },
        {
          id: 8,
          question: "互通城市有哪些城市",
          answer:
            "您好，原住建部标准的昆山市民卡（卡号以'2153'开头）互通城市约80个；2017年10月以后发行的新市民卡和新昆通卡（卡号以'31048315'开头）互通城市达500多个。",
          tips: "小贴士：关注“昆山市民卡”公众号获取互联互通详细名单。",
        },
        {
          id: 9,
          question: "“鹿路通”APP上定制的卡片多久可以发货？",
          answer:
            "您好，发货时间一般为七个工作日。我们会根据实际付款顺序完成定制及发货，如遇节假日或特殊天气，可能会顺延，请您耐心等待。详情可通过店铺订单号查询订单状态。",
          tips: "",
        },
        {
          id: 10,
          question: "昆通卡可以NFC充值么？",
          answer:
            "您好，昆山新市民卡及自2017年10月以后发行的新昆通卡（卡号以'31048315'开头）均可支持NFC充值。",
          tips: "小贴士：关注“昆山市民卡”公众号获取更多NFC充值信息。",
        },
        {
          id: 11,
          question: "“鹿路通”APP充值后，去哪里补登？怎么操作？",
          answer:
            "您好，1补登点查询路径：“鹿路通”APP:服务网点－－补登机布设点或“昆山市民卡”公众号：我的服务——充值网点 2操作流程：“鹿路通”App充值后可持卡至补登点，把卡贴在补登机上，等听到“充值成功”后，充值完成。	（充值过程中切勿移动卡片）",
          tips: "",
        },
        {
          id: 12,
          question: "云充值的补登机是什么？",
          answer: "补登机是云充值读卡器（即在APP充值下单把钱写进卡里的读卡器）",
          tips: "",
        },
        {
          id: 13,
          question: "新市民卡、昆通卡区别？",
          answer:
            "您好，新市民卡是集银行、小额电子钱包（俗称公交钱包）两大功能为一体的智能IC卡。昆通卡是具有小额电子钱包功能的智能卡。",
          tips:
            "小贴士：关注“昆山市民卡”公众号获取更多市民卡及昆通卡应用领域信息。",
        },
        {
          id: 14,
          question: "上车刷了卡，下车忘刷卡，怎么办？",
          answer:
            "您好，乘客下车忘记刷卡，将按上车站点至终点的票价计算费用，并在下次刷卡时补扣。",
          tips: "",
        },
        {
          id: 15,
          question: "新市民卡(B卡）有哪些功能。",
          answer:
            "您好，新市民卡是集银行、小额电子钱包（俗称公交钱包）两大功能为—体的智能IC卡，包括公共交通、园林旅游、图书借阅、体育健身、金融消费等多项功能。",
          tips: "小贴士：关注“昆山市民卡”公众号获取更多新市民卡信息。。",
        },
        {
          id: 16,
          question: "一个人可以办理几张全新市民卡？",
          answer:
            "您好，一人只能办理一张市民卡。市民可持身份证、护照、台胞证等有效证件至昆山农商银行任一网点柜面办理。",
          tips: "小贴士：关注“昆山市民卡”公众号获取更多新市民卡信息。",
        },
        {
          id: 17,
          question: "异地公交卡在昆山刷卡享受几折优惠？",
          answer: "您好，互联互通城市公交卡在我市公交的优惠折扣为9.5折。",
          tips: "小贴士：关注“昆山市民卡”公众号可获取更多互联互通城市信息",
        },
        {
          id: 18,
          question: "学生卡、老年卡、爱心卡怎么办理？",
          answer:
            "您好，（1）学生卡办理：需携带学生卡、学生证件（学生身份证或户口薄或学校证明）及一寸彩色照片；（2）老年卡办理：需携带身份证或户口薄（外地户口需要居住证满三年或社区开满三年证明）及一寸彩色照片。（3）爱心卡办理：需携带身份证、残联证明及一寸彩色照片。 全市5个公交便民服务中心任一网点均可办理。",
          tips: "",
        },
      ],
      helpList1: [],

      loading: false,
      finished: false,
      pageLimit: 10,
      currentPage: 1,
    };
  },
  methods: {
    questionLike() {
      console.log(1);
  
      this.isLike = true;
      this.isOldShow = false;
      this.isNewInputShow = true;
      this.helpList1 = [];
      this.isWhite=true;
      // console.log(this.questionNameLike);
      let list = this.helpList.filter((v) => {
        if (
          v.question.includes(this.questionNameLike) ||
          v.answer.includes(this.questionNameLike) ||
          v.tips.includes(this.questionNameLike)
        ) {
          return v;
        }
      });
      console.log(list);
      this.helpList1 = list;
    },
      

    clearInput() {
      this.questionNameLike = "";
      this.isOldShow = true;
      this.isNewInputShow = false;
      this.helpList1 = JSON.parse(JSON.stringify(this.helpList));
      this.isWhite = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/UseHelp.scss";
</style>

<style lang="scss" scoped>
.headWhite,
.app7White {
  background-color: #ffffff;
}
.container7White {
  background-color: #ffffff;
  margin-top: 8.25rem;
}

.head ::v-deep .OldInput {
 
  height: 5rem;
  background: #ffffff;
  padding: 0;
  border-radius: 2.5rem;
  .van-search__content {
    border-radius: 2.5rem;
    padding-left: 2.625rem;
    background: #ffffff;

    .van-cell {
      padding: 0;

      .van-cell__value--alone .van-field__body .van-field__control {
        font-size: 1.75rem;
        color: #878787;
        margin-left: 0.625rem;
      }

      .van-field__left-icon .van-icon {
        font-size: 2.5rem;
        color: #878787;
      }
    }
  }
}

.NewInputZu {
  display: flex;
  align-items: center;
  p {
    font-size: 1.75rem;
    color: #338989;
    margin-left: 1.75rem;
    white-space: nowrap;

  }
}
.head ::v-deep .NewInput {
  width: 36.625rem;
  height: 5rem;
  background: #f9f9f9;
  padding: 0;
  border-radius: 2.5rem;
  .van-search__content {
    border-radius: 2.5rem;
    padding-left: 2.625rem;
    background: #f9f9f9;

    .van-cell {
      padding: 0;

      .van-cell__value--alone .van-field__body .van-field__control {
        font-size: 1.75rem;
        color: #878787;
        margin-left: 0.625rem;
      }

      .van-field__left-icon .van-icon {
        font-size: 2.5rem;
        color: #878787;
      }
    }
  }
}
</style>